<div class="skeleton-wrapper flex-column flex-100 full-height" *ngIf="!isEditingCreelMapping" [class.skeleton]="isLoadingCreel" vdwDelayedClass="blurry-content-fix" [@fadeIn]="isLoadingCreel">
  <vdw-header [action]="getAction()" [title]="getTitle()" [canShowClose]="true" (closeEvent)="close()" svgIcon="planning-blue"> </vdw-header>
  <mat-divider></mat-divider>
  <article class="planning-item-form__article flex-row">
    <form class="sidebar-content flex-column flex-100" [formGroup]="planningItemForm">
      <div class="flex-row" *ngIf="canChangePlanningItemType()">
        <div class="flex-column gap-16">
          <mat-radio-group class="flex-row-wrap" formControlName="type" (change)="updatePlanningItem()">
            <ng-container *ngFor="let planningItemType of planningItemTypes">
              <mat-radio-button class="flex-column" [value]="planningItemType" *ngIf="canShowPlanningItemType(planningItemType)">
                {{ getPlanningItemTypeLabel(planningItemType) | bmsTranslate }}
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>
      </div>
      <div class="flex-column flex-100">
        <div class="flex-row-wrap">
          <div class="date-input form-field-skeleton-wrapper">
            <vdw-datepicker-form-input
              [inputLabel]="'GENERAL.DATETIME.START_DATE' | bmsTranslate"
              [form]="planningItemForm"
              formControlNameValue="startDate"
              [minValue]="getMinDateForStartDate()"
              [value]="planningItemForm.get('startDate').value"
              (dateChange)="onStartDateChange($event)"
            ></vdw-datepicker-form-input>
          </div>
          <div class="time-input form-field-skeleton-wrapper">
            <mat-form-field class="full-width">
              <mat-label>{{ 'GENERAL.DATETIME.START_TIME' | bmsTranslate }}</mat-label>
              <input matInput appTime formControlName="startTime" (blur)="updateStartTimeWhenInThePast()" />
            </mat-form-field>
          </div>
          <div class="date-input form-field-skeleton-wrapper">
            <vdw-datepicker-form-input
              [inputLabel]="'GENERAL.DATETIME.END_DATE' | bmsTranslate"
              [form]="planningItemForm"
              formControlNameValue="endDate"
              (dateChange)="onEndDateChange($event)"
            ></vdw-datepicker-form-input>
          </div>
          <div class="time-input form-field-skeleton-wrapper">
            <mat-form-field class="full-width">
              <mat-label>{{ 'GENERAL.DATETIME.END_TIME' | bmsTranslate }}</mat-label>
              <input matInput appTime formControlName="endTime" (blur)="updateEndTimeAndEndDate()" />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="canShowRunSpecificFormControls()" class="flex-column flex-100 gap-24">
          <div class="flex-row">
            <ng-container *ngIf="canShowCarpetSpecificControls()">
              <mat-form-field class="full-width">
                <mat-label>{{ 'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1} }}</mat-label>
                <vdw-object-selection
                  formControlName="creel"
                  [objectName]="'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1} | lowercase"
                  [baseRouterLink]="CREEL_BASE_ROUTER_LINK"
                  (selectClicked)="selectCreel()"
                ></vdw-object-selection>
                <mat-error *vdwCanShowErrorForFormControl="'creel'; error: 'required'">
                  {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}</mat-label>
                <vdw-object-selection
                  formControlName="machineQuality"
                  [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | lowercase"
                  [baseRouterLink]="QUALITY_BASE_ROUTER_LINK"
                  [chipValueKey]="QUALITY_CHIP_VALUE_KEY"
                  (selectClicked)="selectMachineQuality()"
                ></vdw-object-selection>
                <mat-error *vdwCanShowErrorForFormControl="'machineQuality'; error: 'required'">
                  {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                </mat-error>
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="canShowWeavingSpecificControls()">
              <mat-form-field class="full-width">
                <mat-label>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1} }}</mat-label>
                <vdw-object-selection
                  formControlName="weaveProduct"
                  [objectName]="'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1} | lowercase"
                  [baseRouterLink]="WEAVE_PRODUCT_BASE_ROUTER_LINK"
                  (selectClicked)="selectWeaveProduct()"
                ></vdw-object-selection>
                <mat-error *vdwCanShowErrorForFormControl="'weaveProduct'; error: 'required'">
                  {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                </mat-error>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="canShowTuftingSpecificControls()">
              <mat-form-field class="full-width">
                <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1} }}</mat-label>
                <vdw-object-selection
                  formControlName="tuftProduct"
                  [objectName]="'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1} | lowercase"
                  [baseRouterLink]="TUFT_PRODUCT_BASE_ROUTER_LINK"
                  (selectClicked)="selectTuftProduct()"
                ></vdw-object-selection>
                <mat-error *vdwCanShowErrorForFormControl="'tuftProduct'; error: 'required'">
                  {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
          <app-production-orders-list
            *ngIf="canShowProductionOrdersList()"
            [planningOrders]="planningItemForm.get('planningOrders').value"
            [machineQualityId]="planningItemForm.get('machineQuality')?.value.id"
            [creelId]="planningItemForm.get('creel')?.value.id"
            [weaveProductId]="planningItemForm.get('weaveProduct')?.value.id"
            [tuftProductId]="planningItemForm.get('tuftProduct')?.value.id"
            [machine]="machine"
            [viewOnly]="!canQueueProductionOrder()"
            (deletePlanningOrder)="deletePlanningOrder($event)"
            (addPlanningOrders)="addPlanningOrders($event)"
            (updatePlanningOrders)="updatePlanningOrders($event)"
            (selectPlanningOrder)="onPlanningOrderSelected($event)"
          ></app-production-orders-list>
          <div *ngIf="isCreelSelected()" class="flex-row">
            <div class="flex-column flex-100 gap-16">
              <div class="flex-row flex-start-center">
                <h3 class="font-weight-semibold">{{ 'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 2} }}</h3>
              </div>
              <div class="flex-row flex-start-center gap-40">
                <div class="flex-column flex-center-start">
                  <div class="flex-row flex-start-center gap-16">
                    <mat-button-toggle-group [value]="!isCurrentPreviewModeActiveCreel()" (change)="onCreelMapViewModeChange($event)">
                      <mat-button-toggle [value]="true">{{ 'MACHINE.DETAILS.THEORETICAL' | bmsTranslate }}</mat-button-toggle>
                      <mat-button-toggle [value]="false">{{ 'MACHINE.DETAILS.ACTIVE' | bmsTranslate }}</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div class="divider"></div>
                <div class="flex-column flex-center-start">
                  <div class="flex-row flex-start-center gap-16">
                    <mat-label>{{ 'TEXTILE_DATA.COLOR.COLOR' | bmsTranslate: {count: 2} }}</mat-label>
                    <mat-slide-toggle [checked]="isCurrentPreviewModeYarnType()" (change)="onCreelTypeViewModeChange($event)"></mat-slide-toggle>
                    <mat-label>{{ 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2} }}</mat-label>
                  </div>
                </div>
              </div>
              <div class="flex-row">
                <div class="flex-column flex-1 gap-24">
                  <div class="flex-row">
                    <app-creel-preview-table
                      [coloredYarnSetsWithStartDent]="planningItemForm.get('creel').value.coloredYarnSetsWithStartDent"
                      [creelMap]="planningItemForm.get('creel').value.mappingForCurrentPositionOnMachine"
                      [previewType]="creelPreviewType"
                      [previewMap]="creelPreviewMap"
                    >
                    </app-creel-preview-table>
                  </div>
                  <div class="flex-row" *ngIf="canChangeRunProperties()">
                    <button mat-stroked-button (click)="editCreelMapping()">{{ 'MACHINE.DETAILS.EDIT_MAPPING' | bmsTranslate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </article>
  <footer class="sidebar-footer flex-row flex-center gap-16" *ngIf="canQueueProductionOrder()">
    <ng-container *ngIf="!isAddingPlanningItem()">
      <div class="button-skeleton-wrapper standard-btn">
        <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'MACHINE.ACTIONS.CREATE_PRODUCTION_ORDER' | bmsTranslate" (click)="createProductionOrderForRun()">
          <mat-icon svgIcon="add-prod-order"></mat-icon>
        </button>
      </div>
      <div class="button-skeleton-wrapper standard-btn">
        <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate" (click)="delete()">
          <mat-icon svgIcon="trash"></mat-icon>
        </button>
      </div>
    </ng-container>
    <div class="button-skeleton-wrapper raised-btn">
      <button mat-flat-button color="primary" (click)="save()" [disabled]="planningItemForm.invalid">
        <ng-container *ngIf="isAddingPlanningItem(); else editingPlanningItem">
          {{ 'GENERAL.ACTIONS.CREATE' | bmsTranslate }}
        </ng-container>
        <ng-template #editingPlanningItem>
          {{ 'GENERAL.ACTIONS.SAVE' | bmsTranslate }}
        </ng-template>
      </button>
    </div>
  </footer>
</div>
<app-edit-creel-mapping
  class="flex-row flex-100"
  *ngIf="isEditingCreelMapping"
  [creel]="planningItemForm.get('creel')?.value"
  (closeEditCreelMapping)="closeEditCreelMapping()"
  (saveCreelMapping)="updateCreelMapping($event)"
></app-edit-creel-mapping>
